import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, PanelGroup, Panel, Popover} from 'react-bootstrap'
import Icon from '../../core/components/Icon'
import {queryActivityRef, queryOpeningTicketPurposeRef} from '../../reference/actions'
import {sendAssignActivityToProviderContactCmd, sendRemoveActivityFromProviderContactCmd, loadContact} from '../actions'
import i18n from '../i18n'
import style from './AssignRemoveActivityFromProviderContactPopover.less'

function activityAggregator(activityReference, openingTicketPurposeReference) {
    return (result, activity) => {
        const includedActivity = activityReference.find((a) => a.uid == activity.activityUid)

        if (includedActivity) {
            const incidentTypes = openingTicketPurposeReference.openingTicketPurposes.filter((otp) => {
                return !!otp.activities.find((a) => a.uid == includedActivity.uid)
            })

            const aggrega = {
                activity: includedActivity,
                incidentTypes: incidentTypes,
                includedIncidentTypeUids: activity.includedIncidentTypes
            }
            result.push(aggrega)
        } else {
            console && console.warn('activity "' + activity.activityUid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

function activityFilter(activities) {
    return (activity) => {
        return activities.find((a) => a.activityUid == activity.uid) == null
    }
}

function openingTicketPurposeFilter(activity) {
    return (otp) => {
        return !!otp.activities.find((a) => a.uid == activity.uid)
    }
}

function isIncidentTypeIncluded(aggrega, incidentType) {
    return aggrega.includedIncidentTypeUids.find((uid) => uid == incidentType.uid) != null
}

function addIncidentType(aggrega, incidentType) {
    const index = aggrega.includedIncidentTypeUids.findIndex((uid) => uid == incidentType.uid)

    var nextIncidentTypeUids = [...aggrega.includedIncidentTypeUids]
    if (index < 0) {
        nextIncidentTypeUids.push(incidentType.uid)
    }
    return nextIncidentTypeUids
}

function removeIncidentType(aggrega, incidentType) {
    const index = aggrega.includedIncidentTypeUids.findIndex((uid) => uid == incidentType.uid)

    var nextIncidentTypeUids = [...aggrega.includedIncidentTypeUids]
    if (index >= 0) {
        nextIncidentTypeUids.splice(index, 1)
    }
    return nextIncidentTypeUids
}

class AssignRemoveActivityFromProviderContactPopover extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            filteredActivityReference: [],
            aggregations: []
        }
    }

    componentWillMount() {
        const {dispatch, contact} = this.props
        Promise.all([
            dispatch(queryActivityRef()),
            dispatch(queryOpeningTicketPurposeRef(contact.company))
        ])
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.activityReference && nextProps.activityReference != this.props.activityReference)
            || (nextProps.openingTicketPurposeReference && nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference)) {
            const {activityReference, openingTicketPurposeReference, contact} = nextProps

            if (activityReference && openingTicketPurposeReference) {
                const aggregations = contact.activities.reduce(activityAggregator(activityReference, openingTicketPurposeReference), [])
                const filteredActivityReference = activityReference.filter(activityFilter(contact.activities))
                this.setState({filteredActivityReference, aggregations})
            }
        }

        if (nextProps.contact != this.props.contact) {
            const {dispatch, contact} = nextProps
            dispatch(queryOpeningTicketPurposeRef(contact.company))
        }
    }

    _sendAssignCmd(event, activity, incidentTypes) {
        const {dispatch} = this.props

        return dispatch(sendAssignActivityToProviderContactCmd(activity, incidentTypes)).then(() => {
            return dispatch(loadContact())
        }).then(() => {
            this.setState({selectedActivityUid: null})
        }).catch(() => {
            this.setState({selectedActivityUid: null})
        })
    }

    _sendRemoveCmd(event, activity) {
        const {dispatch} = this.props

        return dispatch(sendRemoveActivityFromProviderContactCmd(activity)).then(() => {
            return dispatch(loadContact())
        })
    }

    render() {
        const {dispatch, activityReference, openingTicketPurposeReference, contact, onHide, ...others} = this.props
        const {filteredActivityReference, aggregations, selectedActivityUid} = this.state

        const activityHeader = (aggrega) => (
            <h5>
                <span>{aggrega.activity.label}</span>
                <span> ({aggrega.includedIncidentTypeUids.length})</span>
            </h5>
        )

        const incidentTypeHeader = (aggrega, incidentType) => (
            <h5>{incidentType.label}</h5>
        )

        const incidentTypeButton = (aggrega, incidentType) => {
            const included = isIncidentTypeIncluded(aggrega, incidentType)

            if (included) {
                return (
                    <Button
                        bsStyle='link'
                        onClick={(e) => this._sendAssignCmd(e, aggrega.activity, removeIncidentType(aggrega, incidentType))}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }

            return (
                <Button
                    bsStyle='link'
                    onClick={(e) => this._sendAssignCmd(e, aggrega.activity, addIncidentType(aggrega, incidentType))}>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        const activityField = {
            value: selectedActivityUid || '',
            onChange: (event) => {
                const selectedActivityUid = event.target.value
                const selectedActivity = activityReference.find((a) => a.uid == selectedActivityUid)
                const incidentTypes = openingTicketPurposeReference.openingTicketPurposes.filter(openingTicketPurposeFilter(selectedActivity))

                this.setState({selectedActivityUid})
                this._sendAssignCmd(event, selectedActivity, incidentTypes)
            }
        }

        return (
            <Popover
                bsClass='popover-lg popover'
                title={i18n.assignRemoveActivities}
                {...others}>
                <div className={style.addActivity}>
                    <select
                        {...activityField}>
                        <option value=''>{i18n.addActivity} ...</option>
                        {filteredActivityReference.map((activity, index) => (
                            <option
                                key={index}
                                value={activity.uid}>
                                {activity.label}
                            </option>
                        ))}
                    </select>
                </div>
                <PanelGroup>
                    {aggregations.map((aggrega, index) => (
                        <div
                            key={index}
                            className={style.panelWrapper}>
                            <Button
                                bsStyle='link'
                                onClick={(e) => this._sendRemoveCmd(e, aggrega.activity)}>
                                <Icon icon='minus' size='xs' />
                            </Button>
                            <Panel collapsible
                                key={aggrega.activity.uid}
                                className='panel-header'
                                header={activityHeader(aggrega)}>
                                <PanelGroup>
                                    {aggrega.incidentTypes.map((incidentType) => (
                                        <div
                                            key={incidentType.uid}
                                            className={style.panelWrapper}>
                                            {incidentTypeButton(aggrega, incidentType)}
                                            <Panel collapsible
                                                key={incidentType.uid}
                                                header={incidentTypeHeader(aggrega, incidentType)}>
                                            </Panel>
                                        </div>
                                    ))}
                                </PanelGroup>
                            </Panel>
                        </div>
                    ))}
                </PanelGroup>
                <ButtonToolbar>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

AssignRemoveActivityFromProviderContactPopover = connect((state) => ({
    activityReference: state.reference.activityRef,
    openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
    contact: state.provider.contact.contact
}))(AssignRemoveActivityFromProviderContactPopover)

export default AssignRemoveActivityFromProviderContactPopover


// WEBPACK FOOTER //
// ./lib/provider/components/AssignRemoveActivityFromProviderContactPopover.js